export default {
  methods: {
    toggleDrawer() {
      this.$store.commit('toggleDrawer');
    },
    closeDrawer() {
      this.$store.commit('closeDrawer');
    },
    navigateTo(name, params = null) {
      this.$router.push({
        name, params,
      });
    },
  },
};
